export default __webpack_public_path__ + "static/media/redsalud-color.e105c8db.svg";